var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"confirm"},[_c('div',{staticClass:"wrap"},[_c('CotacntFormMail',{staticStyle:{"padding-top":"110px"},attrs:{"type":1}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }